// PilatesPro Global JavaScript - Essential Functions for Shopify

// Smooth scrolling and product functionality
document.addEventListener('DOMContentLoaded', function() {
  // Add smooth scrolling behavior for all anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Product image gallery functionality
  window.changeMainImage = function(imageUrl) {
    const mainImage = document.getElementById('main-product-image');
    if (mainImage) {
      mainImage.src = imageUrl;
    }
  };

  // Scroll to section functionality
  window.scrollToSection = function(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Initialize cart functionality
  initializeCartButtons();
});

// Cart functionality for Shopify
function initializeCartButtons() {
  const cartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  cartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const button = this.querySelector('button[type="submit"]');
      const originalText = button.innerHTML;
      
      // Update button state
      button.innerHTML = 'Adding...';
      button.disabled = true;
      
      // Submit to Shopify cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Success - redirect to cart or show success message
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error:', error);
        button.innerHTML = originalText;
        button.disabled = false;
        alert('Error adding to cart. Please try again.');
      });
    });
  });
}

// Product variant selection
function updateProductVariant() {
  const selects = document.querySelectorAll('select[name*="options"]');
  const hiddenInput = document.querySelector('input[name="id"]');
  
  if (selects.length === 0 || !hiddenInput) return;
  
  // This would need to be customized based on your product variants
  // For now, we'll keep the default variant selected
}

// Utility function for smooth animations
function animateElement(element, animation) {
  element.style.animation = animation;
  element.addEventListener('animationend', function() {
    element.style.animation = '';
  }, { once: true });
}

// Mobile menu toggle (if needed)
function toggleMobileMenu() {
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.menu-overlay');
  
  if (menu) {
    menu.classList.toggle('active');
  }
  if (overlay) {
    overlay.classList.toggle('active');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('PilatesPro theme loaded successfully');
  });
} else {
  console.log('PilatesPro theme loaded successfully');
}
